const ContradictoireConfirmation = ({ checked, onChange }) => {
  return (
    <div className="mb-4 p-3 rounded" style={{ background: "#f8f9fa" }}>
      <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
        Confirmation du contradictoire de 10 jours{" "}
        <span className="text-danger">*</span>
      </label>
      <div className="alert alert-info mb-2" style={{ fontSize: 14 }}>
        Veuillez confirmer que le délai contradictoire de 10 jours a été
        respecté avant cette inscription.
      </div>
      <div className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          id="contradictoire"
          checked={checked}
          onChange={onChange}
        />
        <label className="custom-control-label" htmlFor="contradictoire">
          Je confirme le respect du contradictoire
        </label>
      </div>
      <p
        className="text-muted mt-2 mb-0"
        style={{ fontSize: 13, fontStyle: "italic" }}
      >
        Cette confirmation est obligatoire pour pouvoir inscrire l'allocataire
      </p>
    </div>
  );
};

export default ContradictoireConfirmation;
